import React, { useRef } from "react";
import { useEffect, useContext } from "react";
import BruttoNettoContext from "../BruttoNettoContext";
import extEStCalc from "./extEStCalc";
import extSozVsgCalc from "./extSozVsgCalc";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function Ergebnisse() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);
  const safeHandleBruttoNettoState = useRef(handleBruttoNettoState);

  const bruttoGehalt = bruttoNettoState.bruttoGehalt;
  const abzugsBetrag = bruttoNettoState.abzugsBetrag;
  const steuerAbzug = bruttoNettoState.steuerAbzug;

  useEffect(() => {
    console.log("useEffect running");
    const abgabenBerechnen = () => {
      console.log("bruttoGehalt", bruttoGehalt);

      const { sVsgBeitrag, sVsgSatz } = extSozVsgCalc(bruttoGehalt);

      const einkommenNachAbzug = bruttoGehalt - abzugsBetrag - sVsgBeitrag;
      console.log("sVsgBeitrag", sVsgBeitrag);
      const berechneteSteuerVorAbzug = extEStCalc(einkommenNachAbzug);
      const gesamtSteuerVorAbzug = berechneteSteuerVorAbzug;
      let gesamtSteuer = gesamtSteuerVorAbzug - steuerAbzug;
      gesamtSteuer = Math.max(gesamtSteuer, 0);

      const nettoGehalt = bruttoGehalt - gesamtSteuer - sVsgBeitrag;
      console.log("nettoGehalt", nettoGehalt);

      safeHandleBruttoNettoState.current("steuer", gesamtSteuer.toFixed(2));
      safeHandleBruttoNettoState.current("sVsgBeitrag", sVsgBeitrag.toFixed(2));
      safeHandleBruttoNettoState.current("sVsgSatz", sVsgSatz.toFixed(2));
      safeHandleBruttoNettoState.current("nettoGehalt", nettoGehalt.toFixed(2));
    };

    abgabenBerechnen();
  }, [bruttoGehalt, abzugsBetrag, steuerAbzug, safeHandleBruttoNettoState]);

  return (
    <div>
      <div style={{ "margin-top": "0.5rem" }} className="result trc2">
        SV-Satz{" "}
        <span className="tooltip" data-tooltip-id="tooltip5">
          {" "}
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.sVsgSatz.toLocaleString("de-DE")}%
        </span>
      </div>
      <div className="result trc1">
        SV-Beitrag:
        <span className="help_float_right">
          {" "}
          {bruttoNettoState.sVsgBeitrag.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result trc2">
        Steuer:{" "}
        <span className="help_float_right">
          {bruttoNettoState.steuer.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result net-pay trc1">
        netto:
        <span className="help_float_right">
          {bruttoNettoState.nettoGehalt.toLocaleString("de-DE")}€
        </span>
      </div>
      <ReactTooltip id="tooltip5" place="bottom" variant="info">
        <p>In NÖ ohne Wohnbauförderungsumlage.</p>
      </ReactTooltip>
    </div>
  );
}
